<div class="top-row">
  <h3>{{ title }}</h3>
  <div class="flex-spacer"></div>
  <tp-button buttonStyle="secondary stroke" [enabled]="true" buttonId="toggleLogStream" (click)="toggleLogStream()">
    @if (toggleStreamingButtonIconClass$ | async; as clazz) {<i [class]="clazz"></i>}{{ toggleStreamingButtonText$ | async }}
  </tp-button>
  <tp-button buttonStyle="secondary stroke" [enabled]="true" buttonId="downloadLogs" (click)="downloadLogs.emit()">
    <i class="fa-light fa-download"></i> Download logs
  </tp-button>
</div>
<aside class="tp-liveness-indicator">
  <tp-status-indicator [status]="(streamingStatusIconClass$ | async)!" [class]="(streamingStatusIconClass$ | async)!"/>
  <p [class]="(streamingStatusIconClass$ | async)!">{{ streamingStatusText$ | async }}</p>
</aside>
